import React from "react";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const Error404 = () => {
  const navigate = useNavigate();

  return (
    <Container
      fluid
      className="d-flex align-items-center justify-content-center vh-100"
      style={{
        background: "linear-gradient(135deg, #aa19d6ff 0%, #000000ff 100%)",
      }}
    >
      <Row className="w-100">
        <Col md={{ span: 8, offset: 2 }} lg={{ span: 6, offset: 3 }}>
          <Card
            className="text-center shadow-lg p-4"
            style={{
              background: "linear-gradient(135deg, #7C8C27 0%, #6c1794 100%)",
              border: "none",
              borderRadius: "20px",
              backdropFilter: "blur(10px)",
              color: "white",
            }}
          >
            {/* Animated 404 */}
            <h1
              style={{
                fontSize: "7rem",
                fontWeight: "900",
                textShadow: "3px 3px rgba(0,0,0,0.3)",
                animation: "pulse 2s infinite",
              }}
            >
              404
            </h1>

            <h2 className="mb-3" style={{ fontWeight: "700" }}>
              Oops! Page Not Found
            </h2>
            <p style={{ fontSize: "1.2rem" }}>
              The page you’re looking for doesn’t exist or has been moved.
            </p>

            {/* Button */}
            {/* <Button
              size="lg"
              onClick={() => navigate("/")}
              style={{
                backgroundColor: "#7C8C27",
                border: "none",
                color: "white",
                padding: "12px 28px",
                fontWeight: "600",
                borderRadius: "50px",
                transition: "all 0.3s ease",
              }}
              onMouseOver={(e) =>
                (e.target.style.backgroundColor = "#6c1794")
              }
              onMouseOut={(e) =>
                (e.target.style.backgroundColor = "#7C8C27")
              }
            >
              ⬅ Back to Home
            </Button> */}
          </Card>
        </Col>
      </Row>

      {/* Keyframes */}
      <style>
        {`
          @keyframes pulse {
            0% { transform: scale(1); }
            50% { transform: scale(1.05); }
            100% { transform: scale(1); }
          }
        `}
      </style>
    </Container>
  );
};

export default Error404;
